/*
  TBS Free Gifts (settings live in Shopify admin metafields; see
  snippets/tbs-free-gifts.liquid).
  - Shows the gift box on product pages that have gifts.
  - Keeps the cart in sync: every gift earned by a line in the cart (hidden
    line property _gifts) is present once, with the hidden property
    _free_gift; gift lines no longer earned by anything are removed.
  - The $0 price itself comes from a Shopify automatic discount.
*/
(function () {
  'use strict';

  var ROOT = (window.Theme && window.Theme.routes && window.Theme.routes.root_url) || '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';
  var ON_CART_PAGE = /\/cart\/?$/.test(window.location.pathname);
  var CART_URL_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var nativeFetch = window.fetch.bind(window);
  var running = false;
  var queued = false;
  var silent = false;

  function isGift(item) {
    return !!(item.properties && item.properties._free_gift);
  }

  // Gift variant IDs earned by the non-gift lines in the cart.
  function earnedGifts(items) {
    var ids = [];
    items.forEach(function (item) {
      if (isGift(item) || !item.properties || !item.properties._gifts) return;
      String(item.properties._gifts).split(',').forEach(function (id) {
        id = Number(id);
        if (id && ids.indexOf(id) === -1) ids.push(id);
      });
    });
    return ids;
  }

  function api(path, body) {
    var opts = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return nativeFetch(ROOT + path, opts).then(function (r) { return r.json(); });
  }

  // Returns true when the cart was changed.
  async function reconcile() {
    var cart = await api('cart.js');
    var items = cart.items || [];
    var earned = earnedGifts(items);
    var changed = false;
    var updates = {};
    var seen = {};

    // Gift lines: keep one per earned gift at quantity 1, remove the rest.
    items.forEach(function (item) {
      if (!isGift(item)) return;
      if (earned.indexOf(item.variant_id) === -1 || seen[item.variant_id]) updates[item.key] = 0;
      else if (item.quantity !== 1) updates[item.key] = 1;
      seen[item.variant_id] = true;
    });
    if (Object.keys(updates).length) {
      await api('cart/update.js', { updates: updates });
      changed = true;
    }

    // Add earned gifts that aren't in the cart yet (one at a time, so an
    // out-of-stock gift doesn't block the others).
    var missing = earned.filter(function (id) {
      return !items.some(function (item) { return item.variant_id === id; });
    });
    for (var i = 0; i < missing.length; i++) {
      var res = await api('cart/add.js', {
        items: [{ id: missing[i], quantity: 1, properties: { _free_gift: '1' } }]
      });
      if (res && res.status) console.warn('[TBS free gifts] could not add gift', missing[i], res.description || res.message);
      else changed = true;
    }
    return changed;
  }

  function refresh() {
    if (ON_CART_PAGE) {
      window.location.reload();
      return;
    }
    api('cart.js').then(function (cart) {
      silent = true;
      window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
      silent = false;
      document.querySelectorAll('[data-atc-banner-cart-button] span').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    });
  }

  function sync() {
    if (running) { queued = true; return; }
    running = true;
    reconcile()
      .then(function (changed) { if (changed) refresh(); })
      .catch(function (err) { console.warn('[TBS free gifts]', err); })
      .then(function () {
        running = false;
        if (queued) { queued = false; sync(); }
      });
  }

  // Re-check the cart after the theme (or any app) changes it.
  window.fetch = function (input, init) {
    var p = nativeFetch(input, init);
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (CART_URL_RE.test(url)) p.then(function () { setTimeout(sync, 0); }, function () {});
    return p;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_URL_RE.test(String(url))) {
      this.addEventListener('load', function () { setTimeout(sync, 0); });
    }
    return xhrOpen.apply(this, arguments);
  };

  window.addEventListener('cartcount:update', function () { if (!silent) sync(); });

  // Put the gift box (and its hidden _gifts input) inside the product form.
  // If the product template has the "tbs-kit" gift picker (Custom Liquid block),
  // use it instead: keep a hidden _gifts input in sync with its checkboxes.
  function mountGiftBox() {
    var tpl = document.getElementById('tbs-free-gifts-template');
    var form = document.querySelector('form[data-product-form]');
    if (!tpl || !form) return;

    var kit = document.querySelector('.tbs-kit[data-tbs-gifts]');
    if (kit) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_gifts]';
      form.appendChild(input);
      var update = function () {
        var ids = [].filter.call(kit.querySelectorAll('[data-gift-variant]'), function (cb) { return cb.checked; })
          .map(function (cb) { return cb.getAttribute('data-gift-variant'); });
        input.value = ids.join(',');
        input.disabled = !input.value;
      };
      kit.addEventListener('change', update);
      update();
      return;
    }

    if (form.querySelector('[data-tbs-gifts]')) return;
    var box = tpl.content.cloneNode(true);
    var atc = form.querySelector('.product-form--atc');
    if (atc) atc.parentNode.insertBefore(box, atc);
    else form.appendChild(box);
  }

  function init() {
    mountGiftBox();
    if (document.cookie.indexOf('cart=') > -1) sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
